import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { NWClient } from '../../client/NWClient';
import { LibraryItem } from '../../pages/library/components/library-list/types';
import { revertAll, RootState } from '../../store';
import { fetchDocuments } from '../documents/documentsSlice';

export const fetchTemplates = createAsyncThunk('documents/fetchTemplates', async () => {
  const response = await NWClient.list('document-library');
  return response;
});

export interface TemplatesState {
  templatesList: LibraryItem[];
  status: string;
  error: string;
}

const initialState: TemplatesState = {
  templatesList: [],
  status: 'idle',
  error: '',
};

const templatesSlice = createSlice({
  name: 'templates',
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(fetchTemplates.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(fetchTemplates.fulfilled, (state, action) => {
        state.status = 'succeeded';
        if (Array.isArray(action.payload)) {
          state.templatesList = [...action.payload];
        }
      })
      .addCase(fetchDocuments.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message;
      })
      .addCase(revertAll, () => initialState);
  },
});

export default templatesSlice.reducer;

export const selectAllBKTemplates = (state: RootState) => state.templates.templatesList;
